module.exports = __webpack_public_path__ + "static/media/wordle_solver.83e541a2.png";